/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Info_CopiedInputs */

const en_delivery_board_info_copied = /** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All delivery info copied!`)
};

const es_delivery_board_info_copied = /** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Toda la información copiada!`)
};

const fr_delivery_board_info_copied = /** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les infos de livraison copiées !`)
};

const de_delivery_board_info_copied = /** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Lieferinfos kopiert!`)
};

const id_delivery_board_info_copied = /** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua info pengiriman disalin!`)
};

/** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */
const ja_delivery_board_info_copied = en_delivery_board_info_copied;

/** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */
const zh_delivery_board_info_copied = en_delivery_board_info_copied;

/** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */
const ar_delivery_board_info_copied = en_delivery_board_info_copied;

/** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */
const it_delivery_board_info_copied = en_delivery_board_info_copied;

/** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */
const ru_delivery_board_info_copied = en_delivery_board_info_copied;

/** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */
const pt_delivery_board_info_copied = en_delivery_board_info_copied;

/** @type {(inputs: Delivery_Board_Info_CopiedInputs) => LocalizedString} */
const ko_delivery_board_info_copied = en_delivery_board_info_copied;

/**
* | output |
* | --- |
* | "All delivery info copied!" |
*
* @param {Delivery_Board_Info_CopiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_info_copied = /** @type {((inputs?: Delivery_Board_Info_CopiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Info_CopiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_info_copied(inputs)
	if (locale === "es") return es_delivery_board_info_copied(inputs)
	if (locale === "fr") return fr_delivery_board_info_copied(inputs)
	if (locale === "de") return de_delivery_board_info_copied(inputs)
	if (locale === "ja") return ja_delivery_board_info_copied(inputs)
	if (locale === "zh") return zh_delivery_board_info_copied(inputs)
	if (locale === "ar") return ar_delivery_board_info_copied(inputs)
	if (locale === "id") return id_delivery_board_info_copied(inputs)
	if (locale === "it") return it_delivery_board_info_copied(inputs)
	if (locale === "ru") return ru_delivery_board_info_copied(inputs)
	if (locale === "pt") return pt_delivery_board_info_copied(inputs)
	return ko_delivery_board_info_copied(inputs)
});